<p style="display: none;">Pawerful PetShop. Tienda de mascotas de México</p>
<div id="modal-container">
    <div class="modal-background">
        <div class="modal">
            <div class="monitoring-form-image">
                <img src="assets/images/sleep.png" alt="No te duermas, tenemos muchos productos de Pawerful para tu mascota." loading="lazy"/>
            </div>
            <section class="monitoring-form-content">
                <h1>Tu cuenta presenta una inactividad</h1>
                <br><br>
                <h2>¿Deseas continuar con tu sesión activa?</h2>
                <br>
                <div class="multiple">
                    <div class="control-btn col5">
                        <button (click)="fnHideModal()" class="fondo-blue">Aceptar</button>
                    </div>
                    <div class="control-btn col5 offset2">
                        <button (click)="fnCerrarSesion()" class="fondo-purple">Cancelar</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>




<section class="alerta" *ngIf=" showAlerta ">
    <div class="alerta-container" [ngClass]="newAlerta.estilo">
        <h5>
            <div>
                <span [ngClass]="newAlerta.icono"></span>
            </div>
            <div>
                <b>{{ newAlerta.titulo }}</b>
            </div>
            <div (click)="fnCloseAlerta()">
                <span class="fas fa-times"></span>
            </div>
        </h5>
        <div [innerHTML]="newAlerta.mensaje | safe: 'html'"> </div>
    </div>
</section>

<div class="loader-container" *ngIf=" showLoader ">
    <div class="lds-circle">
        <img src="assets/images/paw-foot.png" alt="Pawerful PetShop" loading="lazy"/>
    </div>
    <div id="loader-message">
        <h1>{{newMensaje}}</h1>
    </div>
</div>




<section class="menu">
    <div class="menu-header-movil">
        <div (click)="fnAccionMenu( false )">
            <span><i class="fas fa-bars fa-2x"></i></span>
        </div>
        <div [routerLink]="['']">
            <img src="assets/images/logo-big.png" alt="Pawerful PetShop" loading="lazy"/>
        </div>
        <div (click)="fnLinkCarrito()">
            <p>
                <i class="fas fa-shopping-cart"></i>
            </p>
            <p class="circle">
                <caption>{{ newUser.totalProductos }}</caption>
            </p>
        </div>
    </div>
    <div class="menu-body-movil seccion-busqueda">
        <input class="txtBusqueda" [(ngModel)]="txtBusqueda" type="text" placeholder="Busca aquí tus productos..." (keyup.enter)="fnBuscarProductos()" (keyup)="fnBuscarSuguerencias($event)">
        <button (click)="fnBuscarProductos()" aria-label="Buscar productos"><i class="fas fa-search"></i></button>
        <section class="sugerencias" *ngIf=" conSugerencias ">
            <section>
                <h3>Sugerencias</h3>
                <div *ngIf=" listaSugerencias.productos.length > 0 ">
                    <p (click)="fnIrSugerenciaProducto( newProducto )" *ngFor="let newProducto of listaSugerencias.productos">
                        {{ newProducto.texto }}
                    </p>
                </div>
            </section>
            <section>
                <h3>Categorías</h3>
                <div *ngIf=" listaSugerencias.categorias.length > 0 ">
                    <p (click)="fnIrSugerenciaCategoria( newCategoria )" *ngFor="let newCategoria of listaSugerencias.categorias">
                        {{ newCategoria.texto }}
                    </p>
                </div>
                <div *ngIf=" listaSugerencias.categorias.length === 0 ">
                    <p> Sin resultados </p>
                </div>
            </section>
            <section>
                <h3>Marcas</h3>
                <div *ngIf=" listaSugerencias.marcas.length > 0 ">
                    <p (click)="fnIrSugerenciaMarca( newMarca )" *ngFor="let newMarca of listaSugerencias.marcas">
                        {{ newMarca.texto }}
                    </p>
                </div>
                <div *ngIf=" listaSugerencias.marcas.length === 0 ">
                    <p> Sin resultados </p>
                </div>
            </section>
        </section>
    </div>

    <div class="menu-content-movil" [@tgMenu]="stateMenu">
        <div>
            <h4 (click)="fnAccionMenu( false )" *ngIf=" newUser.session " [routerLink]="['mi-cuenta']">
                <p><i class="fas fa-user"></i></p>
                <p>Mi cuenta</p>
            </h4>
            <h4 (click)="fnAccionMenu( false )" [routerLink]="['/nosotros']" routerLinkActive="active">
                <p><i class="fas fa-paw"></i></p>
                <p>Nosotros</p>
            </h4>
            <!-- <h4 (click)="fnAccionMenu( false )" [routerLink]="['/citas']" routerLinkActive="active">
				<p><i class="fas fa-edit"></i></p>
				<p>Citas</p>
			</h4> -->
            <h4 (click)="fnAccionMenu( false )" [routerLink]="['/ubicaciones']" routerLinkActive="active">
                <p><i class="fas fa-map-marked-alt"></i></p>
                <p>Ubicaciones</p>
            </h4>
            <h4 (click)="fnSeleccionCategoria( newItem )" *ngFor="let newItem of listaCategorias">
                <p>
                    <img [src]=" newItem.fotografia " [alt]="newItem.nombre" loading="lazy"/>
                </p>
                <p>{{ newItem.nombre }}</p>
            </h4>
            <h4 (click)="fnAccionMenu( false )" *ngIf=" !newUser.session " [routerLink]="['acceso']">
                <p><i class="fas fa-user"></i></p>
                <p>Iniciar sesión</p>
            </h4>
            <h4 (click)="fnCerrarSesion()" *ngIf=" newUser.session ">
                <p><i class="fas fa-sign-out-alt"></i></p>
                <p>Cerrar sesión</p>
            </h4>
        </div>
        <section (click)="fnAccionMenu( false )"></section>
    </div>

    <div class="menu-header-tablet">
        <p>
            <!-- <a href="" title="">
				(55) 8095 9898
			</a> / 
			<a href="" title="">
				Tel. (55) 7030 9015
			</a> -->
        </p>
        <p *ngIf=" !newUser.session ">
            <a [routerLink]="['acceso']" title="">
				Iniciar sesión <i class="far fa-user color-white"></i>
			</a>
        </p>
        <div class="color-white state-user" *ngIf=" newUser.session ">
            Saldo {{ newUser.saldo | currency:newUser.divisa:'symbol':'.2-2' }} <span class="color-blue">Uriel</span> Puntos {{ newUser.puntos }} <span class="color-blue">Leal</span> {{ newUser.nombre }} <i class="far fa-user color-white"></i>
            <section class="menu-user fondo-blue">
                <div>
                    <a [routerLink]="['mi-cuenta']">Mi Cuenta</a>
                </div>
                <div>
                    <a (click)="fnCerrarSesion()">Cerrar sesión</a>
                </div>
            </section>
        </div>
    </div>
    <div class="menu-body-tablet">
        <section>
            <div [routerLink]="['']">
                <img src="assets/images/logo-big.png" alt="Pawerful PetShop" loading="lazy"/>
            </div>
            <div>
                <section [routerLink]="['']">
                    <p>Home</p>
                </section>
                <section [routerLink]="['/nosotros']" routerLinkActive="active">
                    <p>Nosotros</p>
                </section>
                <!-- <section [routerLink]="['/citas']" routerLinkActive="active">
					<p>Citas</p>
				</section> -->
                <section (click)="fnAccionCategorias()" (mouseenter)="fnAccionCategorias()" [ngClass]="{ 'active':showMenuCategorias }">
                    <p>Categorías</p>
                </section>
                <section [routerLink]="['/ubicaciones']" routerLinkActive="active">
                    <p>Ubicaciones</p>
                </section>
            </div>
            <div (click)="fnLinkCarrito()">
                <p>
                    <i class="fas fa-shopping-cart"></i>
                </p>
                <p class="circle">
                    <caption>{{ newUser.totalProductos }}</caption>
                </p>
            </div>
        </section>
        <section>
            <div class="seccion-busqueda">
                <input class="txtBusqueda" [(ngModel)]="txtBusqueda" type="text" placeholder="Busca aquí tus productos..." (keyup.enter)="fnBuscarProductos()" (keyup)="fnBuscarSuguerencias($event)">
                <button (click)="fnBuscarProductos()" aria-label="Buscar productos"><i class="fas fa-search"></i></button>
                <section class="sugerencias" *ngIf=" conSugerencias ">
                    <section>
                        <h3>Sugerencias</h3>
                        <div *ngIf=" listaSugerencias.productos.length > 0 ">
                            <p (click)="fnIrSugerenciaProducto( newProducto )" *ngFor="let newProducto of listaSugerencias.productos">
                                {{ newProducto.texto }}
                            </p>
                        </div>
                    </section>
                    <section>
                        <h3>Categorías</h3>
                        <div *ngIf=" listaSugerencias.categorias.length > 0 ">
                            <p (click)="fnIrSugerenciaCategoria( newCategoria )" *ngFor="let newCategoria of listaSugerencias.categorias">
                                {{ newCategoria.texto }}
                            </p>
                        </div>
                        <div *ngIf=" listaSugerencias.categorias.length === 0 ">
                            <p> Sin resultados </p>
                        </div>
                    </section>
                    <section>
                        <h3>Marcas</h3>
                        <div *ngIf=" listaSugerencias.marcas.length > 0 ">
                            <p (click)="fnIrSugerenciaMarca( newMarca )" *ngFor="let newMarca of listaSugerencias.marcas">
                                {{ newMarca.texto }}
                            </p>
                        </div>
                        <div *ngIf=" listaSugerencias.marcas.length === 0 ">
                            <p> Sin resultados </p>
                        </div>
                    </section>
                </section>
            </div>
        </section>
    </div>


    <div class="menu-header">
        <p>
            <!-- <a href="" title="">
				(55) 8095 9898
			</a> / 
			<a href="" title="">
				Tel. (55) 7030 9015
			</a> -->
        </p>
        <p *ngIf=" !newUser.session ">
            <a [routerLink]="['acceso']" title="">
				Iniciar sesión <i class="far fa-user color-white"></i>
			</a>
        </p>
        <div class="color-white state-user" *ngIf=" newUser.session ">
            Saldo {{ newUser.saldo | currency:newUser.divisa:'symbol':'.2-2' }} <span class="color-blue">Uriel</span> Puntos {{ newUser.puntos }} <span class="color-blue">Leal</span> {{ newUser.nombre }} <i class="far fa-user color-white"></i>
            <section class="menu-user fondo-blue">
                <div>
                    <a [routerLink]="['mi-cuenta']">Mi Cuenta</a>
                </div>
                <div>
                    <a (click)="fnCerrarSesion()">Cerrar sesión</a>
                </div>
            </section>
        </div>
    </div>
    <div class="menu-body">
        <div [routerLink]="['']">
            <img src="assets/images/logo-big.png" alt="Pawerful PetShop" loading="lazy"/>
        </div>
        <div>
            <section [routerLink]="['']">
                <p>Home</p>
            </section>
            <section [routerLink]="['/nosotros']" routerLinkActive="active">
                <p>Nosotros</p>
            </section>
            <!-- <section [routerLink]="['/citas']" routerLinkActive="active">
				<p>Citas</p>
			</section> -->
            <section (click)="fnAccionCategorias()" (mouseenter)="fnAccionCategorias()" [ngClass]="{ 'active':showMenuCategorias }">
                <p>Categorías</p>
            </section>
            <section [routerLink]="['/ubicaciones']" routerLinkActive="active">
                <p>Ubicaciones</p>
            </section>
        </div>
        <div class="seccion-busqueda">
            <input class="txtBusqueda" [(ngModel)]="txtBusqueda" type="text" placeholder="Busca aquí tus productos..." (keyup.enter)="fnBuscarProductos()" (keyup)="fnBuscarSuguerencias($event)">
            <button (click)="fnBuscarProductos()" aria-label="Buscar productos"><i class="fas fa-search"></i></button>
            <section class="sugerencias" *ngIf=" conSugerencias ">
                <section>
                    <h3>Sugerencias</h3>
                    <div *ngIf=" listaSugerencias.productos.length > 0 ">
                        <p (click)="fnIrSugerenciaProducto( newProducto )" *ngFor="let newProducto of listaSugerencias.productos">
                            {{ newProducto.texto }}
                        </p>
                    </div>
                </section>
                <section>
                    <h3>Categorías</h3>
                    <div *ngIf=" listaSugerencias.categorias.length > 0 ">
                        <p (click)="fnIrSugerenciaCategoria( newCategoria )" *ngFor="let newCategoria of listaSugerencias.categorias">
                            {{ newCategoria.texto }}
                        </p>
                    </div>
                    <div *ngIf=" listaSugerencias.categorias.length === 0 ">
                        <p> Sin resultados </p>
                    </div>
                </section>
                <section>
                    <h3>Marcas</h3>
                    <div *ngIf=" listaSugerencias.marcas.length > 0 ">
                        <p (click)="fnIrSugerenciaMarca( newMarca )" *ngFor="let newMarca of listaSugerencias.marcas">
                            {{ newMarca.texto }}
                        </p>
                    </div>
                    <div *ngIf=" listaSugerencias.marcas.length === 0 ">
                        <p> Sin resultados </p>
                    </div>
                </section>
            </section>
        </div>
        <div (click)="fnLinkCarrito()">
            <p>
                <i class="fas fa-shopping-cart"></i>
            </p>
            <p class="circle">
                <caption>{{ newUser.totalProductos }}</caption>
            </p>
        </div>
    </div>

</section>


<section class="menu-categorias" *ngIf=" showMenuCategorias " (mouseleave)=" fnAccionCategorias() ">
    <div *ngFor="let newItem of listaCategorias">
        <h3>{{ newItem.nombre }}</h3>
        <section>
            <div *ngFor="let newSub of newItem.subcategorias | orderBy:'nombre'" (click)="fnSeleccionSubcategoria( newSub )">
                <p>{{ newSub.nombre }}</p>
            </div>
        </section>
    </div>
</section>


<section class="redes">
    <div>
        <a href="https://www.facebook.com/pawerfulMX" target="_blank" title="pawerfulMX" rel="noopener">
            <img src="assets/images/redesSociales/facebook.png" alt="PawerfulMX" loading="lazy"/>
        </a>
    </div>
    <div>
        <a href="https://twitter.com/PawerfulMX" target="_blank" title="pawerfulMX" rel="noopener">
            <img src="assets/images/redesSociales/twitter.png" alt="PawerfulMX" loading="lazy"/>
        </a>
    </div>
    <div>
        <a href="https://www.instagram.com/pawerfulmx/" target="_blank" title="pawerfulMX" rel="noopener">
            <img src="assets/images/redesSociales/instagram.png" alt="pawerfulmx" loading="lazy"/>
        </a>
    </div>
</section>

<a class="contacto" href="http://ivt.mx/e7XFv" title="pawerfulMX" target="_blank" rel="noopener">
    <img src="assets/images/redesSociales/whatsapp.png" alt="PawerfulMX" loading="lazy"/>
</a>

<router-outlet></router-outlet>

<section class="footer">
    <div class="footer-header">
        <section>
            <p>Suscríbete a Nuestro Newsletter y recibe las mejores ofertas</p>
        </section>
        <div>
            <input [(ngModel)]="correoElectronico" type="text" placeholder="Ingresa tu correo electrónico">
            <button (click)="fnSuscribir()" class="fondo-blue">Suscribete</button>
        </div>
    </div>
    <div class="footer-body">
        <figure>
            <section [routerLink]="['']">
                <img src="assets/images/logo-big.png" alt="Pawerful PetShop" loading="lazy"/>
            </section>
        </figure>
        <figcaption>
            <section>
                <h4>
                    <p>CONTACTO</p>
                </h4>
                <div>
                    <a [routerLink]="['/contacto']" title="Contáctanos">Contáctanos</a>
                </div>
                <div>
                    <a [routerLink]="['/nosotros']" title="¿Quiénes somos?">¿Quiénes somos?</a>
                </div>
                <div>
                    <a href="mailto:contacto@pawerful.com" title="Contactanos">Email: contacto@pawerful.com</a>
                </div>
                <div>
                    <a target="_blank" href="http://ivt.mx/e7XFv" title="Whatsapp">WhatsApp: (56) 2165 6563</a>
                </div>
                <!-- <div>
					<a href="tel:5570309015" title="Teléfono">Tel: (55) 7030 90 15</a>
				</div> -->
            </section>
            <section>
                <h4>
                    <p>SERVICIO AL CLIENTE</p>
                </h4>
                <div>
                    <a [routerLink]="['/ayuda']" title="Ayuda">Ayuda</a>
                </div>
                <div>
                    <a [routerLink]="['/como-comprar']" title="Cómo comprar">Cómo comprar</a>
                </div>
                <div>
                    <a [routerLink]="['aviso-privacidad']" title="Aviso de privacidad">Aviso de privacidad</a>
                </div>
                <div>
                    <a [routerLink]="['terminos-condiciones']" title="Términos y condiciones">Términos y condiciones</a>
                </div>
            </section>
            <section>
                <h4>
                    <p>FORMAS DE PAGO</p>
                </h4>
                <div>
                    <img src="assets/images/formas-pago.png" alt="Formas de pago" loading="lazy"/>
                </div>
            </section>
            <section>
                <h4>
                    <p>REDES SOCIALES</p>
                </h4>
                <section>
                    <div>
                        <a href="https://www.facebook.com/pawerfulMX" target="_blank" title="pawerfulMX" rel="noopener">
                            <img src="assets/images/redesSociales/facebook.png" alt="PawerfulMX" loading="lazy"/>
                        </a>
                    </div>
                    <div>
                        <a href="https://twitter.com/PawerfulMX" target="_blank" title="pawerfulMX" rel="noopener">
                            <img src="assets/images/redesSociales/twitter.png" alt="PawerfulMX" loading="lazy"/>
                        </a>
                    </div>
                    <div>
                        <a href="https://www.instagram.com/pawerfulmx/" target="_blank" title="pawerfulMX" rel="noopener">
                            <img src="assets/images/redesSociales/instagram.png" alt="pawerfulmx" loading="lazy"/>
                        </a>
                    </div>
                </section>
            </section>
        </figcaption>
    </div>
    <div class="footer-bottom">
        <p>
            Pawerful 2019 / Todos los Derechos Reservados
        </p>
    </div>
</section>